import ctLogo from './icons/icon_dtr.svg'
import iconPrinter from './icons/icon_printer.svg'
import iconRightArrow from './icons/icon_arrow_right.svg'
import iconLeftArrow from './icons/icon_arrow_left.svg'
import iconSearch from './icons/icon_search.svg'
import mLogo from './icons/rudetective-m.svg'

export default () => {
    // gray line (header)
    document.getElementById('ctlogo').innerHTML = ctLogo
    // mobile logo
    document.querySelector('.header__logo--mobile .logo--mobile').innerHTML = mLogo
    // footer
    document.getElementById('footerDtr').innerHTML = ctLogo
    // slider arrows

    document.querySelectorAll('.carousel__button--prev').forEach((el) => {
        el.innerHTML = iconLeftArrow
    })
    document.querySelectorAll('.carousel__button--next').forEach((el) => {
        el.innerHTML = iconRightArrow
    })

    // printer icon

    if (document.getElementById('iconPrinter'))
        document.getElementById('iconPrinter').innerHTML = iconPrinter

    // search icon
    if (document.getElementById('iconSearch'))
        document.getElementById('iconSearch').innerHTML = iconSearch
}
